var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41447 12.7606L11.7615 6.72313C13.1602 5.18895 13.424 2.98696 12.297 1.77767C11.1781 0.568373 9.09999 0.784963 7.70129 2.31914L1.89864 8.88C0.891574 9.99002 0.691758 11.5603 1.49901 12.4357C2.30627 13.3111 3.80089 13.1576 4.80796 12.0476L9.68345 6.54264C10.2989 5.86579 10.4348 4.90919 9.93922 4.36772C9.44368 3.83527 8.51653 3.91649 7.9011 4.59333L3.48917 9.57489",
    stroke: "url(#paint0_linear_22874_5292)",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22874_5292",
    x1: 1,
    y1: 7,
    x2: 13,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456565"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment_icon.72aa14dc5366517f4fbf19fd7ad77c0c.svg";
export { ForwardRef as ReactComponent };